// Client ID OAuth Google — public (exposé dans le frontend). Surchargeable via
// VITE_GOOGLE_CLIENT_ID au build.
export const GOOGLE_CLIENT_ID: string =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ??
  "853559911449-e3aibuj0dl6s8gb8l9ema9rnn7qaimdq.apps.googleusercontent.com";
